/* eslint no-console: 0, no-native-reassign: 0, no-undef: 0 */
/* global Stripe, listingJSON */
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { InboxContainer } from './inbox-container';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { PastBookings, RequestedBookings, AllOtherBookings } from './data/inbox-page-data';
import { ErrorPage } from '../app-error-page/error-page';
import Bundles from '../../../api/api-bundles';
import { updateExperience } from '../app-main/actions/nux';
import { getUserExperiences } from '../../../assets/js/nux';
import { TabsContainer } from './tabs-container';
import { NotificationBanner } from '../elements-banner/notification-banner';
import { get } from 'lodash';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { withTypeFormSurvey } from './with-survey-HOC';
import { InboxPhishingBanner } from './InboxPhishingBanner';

// @BookingsMain
// Switches views between 'All' bookings
// and 'Accepted' & 'Past' bookings
//
// API calls:
// /v1/bundles/bookings-inbox/?q=accepted
// /v1/bundles/bookings-inbox/?q=past
//
// SORT calls, replaced q=all:
// /v1/bundles/bookings-inbox/?q=requested
// /v1/bundles/bookings-inbox/?q=not_requested

//
// states: details, threads
//
// sort of 'not_requested' will look at url changes for pagination
// sort of 'accepted', 'past', 'requested' will look at component state changes for pagination

class BookingsMain extends React.Component {
  constructor (props, context) {
    super(props, context);

    this.state = {
      bookings: [],
      pastBookings: [],
      requestedBookings: [],
      count: 0,
      pastBookingsCount: 0,
      requestedCount: 0,
      acceptedPageNum: 1,
      pastPageNum: 1,
      requestedPageNum: 1,
      isLoading: false,
      pastIsLoading: false,
      requestedIsLoading: false,
      pastIsLoadingRequested: false,
      isError: false,
      isErrorRequested: false,
      hostResponse: {},
      cancelPolicyBannerID: '',
      surveyId: ''
    };
    this.allInboxCb = this.allInboxCb.bind(this);
    this.acceptedInboxCb = this.acceptedInboxCb.bind(this);
    this.requestedCB = this.requestedCB.bind(this);
    this.getInboxBundles = this.getInboxBundles.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);
    this.paginateInbox = this.paginateInbox.bind(this);
    this.paginatePastInbox = this.paginatePastInbox.bind(this);
    this.paginateRequestedInbox = this.paginateRequestedInbox.bind(this);
    this.getPageNumber = this.getPageNumber.bind(this);
    this.reloadPage = this.reloadPage.bind(this);
    this.updateNux = this.updateNux.bind(this);
    this.cancelPolicyBannerRedirect = this.cancelPolicyBannerRedirect.bind(this);
    this.renderGuestUpdateBanner = this.renderGuestUpdateBanner.bind(this);
  }

  componentWillMount () {
    let origin;
    const page = this.getPageNumber() || 1;
    const { state } = this.props.location;
    const { path } = this.props.route;
    const viewed = 'inbox' === path ? 'Viewed Inbox' : 'Viewed Bookings';
    const inboxSettings = {
      page,
      callback: 'inbox' === path ? this.allInboxCb : this.acceptedInboxCb
    };
    this.getInboxBundles(inboxSettings);
    if ('inbox' === path) {
      /* render requested section */
      const reqPageNum = this.getPageNumber(true);
      const requestedSettings = {
        sortQuery: 'requested',
        page: reqPageNum,
        callback: this.requestedCB
      };
      this.getInboxBundles(requestedSettings);
    }
    if (state && state.prevPath !== path) {
      origin = state.prevPath;
    }
    analyticsIntegrations.inboxProductView(viewed, origin);
  }

  componentDidMount () {
    document.title = this.props.intl.formatMessage({ id: 'inbox.bookings_main.title', defaultMessage: 'Inbox | Peerspace' });
    const { accessToken, profile, location } = this.props;
    const isHost = _.get(profile, 'data.is_host');
    if (isHost) {
      getUserExperiences('name=select-cancellation-policy-banner', accessToken, (res) => {
        const showCancelPolicyBanner = _.some(res.data, { name: 'select-cancellation-policy-banner' });
        const cancelPolicyBannerExperienceId = _.get(_.filter(res.data, { name: 'select-cancellation-policy-banner' }), ['0', '_id']);
        if (showCancelPolicyBanner) {
          this.setState({ cancelPolicyBannerID: cancelPolicyBannerExperienceId }, () => {
            const message = (
              <div>
                <img
                  src="/web-2/assets/images/check-box-white.png?v=rb"
                  alt={this.props.intl.formatMessage({ id: 'inbox.bookings_main.checkbox_alt', defaultMessage: 'check' })}
                  style={{ height: 18, marginRight: 12 }}
                />
                <FormattedMessage
                  id='inbox.bookings_main.banner_message'
                  defaultMessage="We've added new cancellation policies. Select your policies for your spaces now. {select}"
                  values={{
                    select: <span onClick={this.cancelPolicyBannerRedirect}>
                      <FormattedMessage
                        id='inbox.bookings_main.select_policy'
                        defaultMessage="Select Policy"
                      />
                    </span>
                  }}
                />
              </div>
            );

            ReactDOM.render(
              <NotificationBanner
                showClose
                staticBanner
                message={message}
                customClass="pale-blue-banner"
                onClose={this.updateNux}
              />, document.getElementById('banner-container')
            );
          });
        }
      });
    }

    if ('guestUpdateSuccess' === location.state) {
      this.renderGuestUpdateBanner();
    }
  }

  componentDidUpdate () {
  }

  componentWillReceiveProps (nextProps) {
    // componentWillReceiveProps only applies to sort of 'all'
    const page = this.getPageNumber();
    if (nextProps.location) {
      const nextPage = nextProps.location.query.page;
      const { path } = this.props.route;
      if (nextPage && (page !== nextPage)) {
        const inboxSettings = {
          page: nextPage,
          callback: 'inbox' === path ? this.allInboxCb : this.acceptedInboxCb
        };
        this.getInboxBundles(inboxSettings);
      }
    }
  }

  getPageNumber (requested) {
    let pageNumber;
    if (requested) {
      pageNumber = this.state.requestedPageNum;
    } else {
      pageNumber = this.props.location.query.page;
    }
    return pageNumber;
  }

  // Calls Bundles API
  getInboxBundles (inboxSettings) {
    const { sortQuery, page, callback } = inboxSettings;
    const accessToken = this.getAccessToken();
    const { limit, sort } = this.props.settings;
    const offset = page ? (page - 1) * limit : 0;
    const path = `bookings-inbox/?limit=${limit}&offset=${offset}&q=${sortQuery ? sortQuery : sort}`;
    if (accessToken) {
      if ('past' === sortQuery) {
        this.setState({ pastIsLoading: true });
      } else if ('requested' === sortQuery) {
        this.setState({ requestedIsLoading: true });
      } else {
        this.setState({ isLoading: true });
      }
      Bundles.read(path, accessToken, (response) => {
        if (response.error || 400 < response.statusCode) {
          return this.setState({ isError: true });
        }
        this.setState({ isError: false, isLoading: false, pastIsLoading: false, requestedIsLoading: false });
        return callback(response);
      });
    }
  }

  getAccessToken () {
    let accessToken;
    if (this.props.params.accessToken) {
      accessToken = this.props.params.accessToken;
    } else if (document && document.cookie) {
      accessToken = PSSessions.Cookies.get('PSAccess');
    } else {
      accessToken = null;
    }
    return accessToken;
  }

  reloadPage () {
    location.reload();
  }

  // Callback for 'Requested' inbox

  requestedCB (response) {
    return this.setState({
      requestedBookings: response.bookings,
      requestedCount: response.total_count,
      hostResponse: response.host_responsiveness
    });
  }

  // Callback for 'All' Inbox page
  allInboxCb (response) {
    return this.setState({
      bookings: response.bookings,
      count: response.total_count,
      pastBookings: [],
      acceptedPageNum: 1,
      pastPageNum: 1,
      pastBookingsCount: 0
    });
  }

  // Callback for 'Accepted & Past' Inbox page
  acceptedInboxCb (response) {
    this.setState({
      bookings: response.bookings,
      count: response.total_count,
      acceptedPageNum: this.state.acceptedPageNum,
      hostResponse: response.host_responsiveness
    });
    const inboxSettings = {
      sortQuery: 'past',
      page: this.state.pastPageNum,
      callback: (pastResponse) => {
        this.setState({
          pastBookings: pastResponse.bookings,
          pastBookingsCount: pastResponse.total_count
        });
      }
    };
    this.getInboxBundles(inboxSettings);
  }

  paginateRequestedInbox (key) {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    const inboxSettings = {
      sortQuery: 'requested',
      page: key.eventKey,
      callback: (response) => {
        this.setState({
          requestedBookings: response.bookings,
          requestedBookingsCount: response.total_count,
          requestedPageNum: key.eventKey
        });
      }
    };
    return this.getInboxBundles(inboxSettings);
  }

  paginateInbox (key) {
    const { settings } = this.props;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    if ('accepted' === settings.sort) {
      const inboxSettings = {
        page: key.eventKey,
        callback: (response) => {
          this.setState({
            bookings: response.bookings,
            count: response.total_count,
            acceptedPageNum: key.eventKey
          });
        }
      };
      return this.getInboxBundles(inboxSettings);
    }
    return this.context.router.push({ pathname: '/inbox', query: { page: key.eventKey } });
  }

  paginatePastInbox (key) {
    const inboxSettings = {
      sortQuery: 'past',
      page: key.eventKey,
      callback: (response) => {
        this.setState({
          pastBookings: response.bookings,
          pastBookingsCount: response.total_count,
          pastPageNum: key.eventKey
        });
      }
    };
    return this.getInboxBundles(inboxSettings);
  }

  cancelPolicyBannerRedirect () {
    const { dispatch } = this.props;
    const { cancelPolicyBannerID } = this.state;
    if (cancelPolicyBannerID) {
      dispatch(updateExperience(cancelPolicyBannerID))
        .then(() => { window.location.href = '/mylistings'; });
    }
  }

  updateNux () {
    const { dispatch } = this.props;
    const { cancelPolicyBannerID } = this.state;
    if (cancelPolicyBannerID) {
      dispatch(updateExperience(cancelPolicyBannerID));
    }
  }

  renderGuestUpdateBanner () {
    ReactDOM.render(
      <SharedIntlProviderHOC>
        <NotificationBanner
          showClose
          timing={4.6}
          message={
            <div className="overtime-banner">
              <ul className="text-center list-inline">
                <li className="text-large heavy">
                  <i className="ico ico-md icon-confirmed-check" />
                </li>
                <li>
                  <FormattedMessage
                    id='inbox.bookings_main.request_sent'
                    defaultMessage="Booking update request sent"
                  />
                </li>
              </ul>
            </div>
          }
        />
      </SharedIntlProviderHOC>, document.getElementById('banner-container'));
  }

  render () {
    const { settings, route, location, profile } = this.props;
    const {
      bookings,
      pastBookings,
      count,
      pastBookingsCount,
      pastPageNum,
      isLoading,
      pastIsLoading,
      acceptedPageNum,
      isError,
      requestedCount,
      requestedBookings,
      requestedIsLoading,
      requestedPageNum,
      hostResponse
    } = this.state;
    const { pageObj } = settings;
    const ssoid = profile.SSOid;
    let page = 1;
    let mainContainerSettings = settings.pageObj;

    /* make sure tabs and pagination sections render correctly */
    if ('inbox' === route.path) {
      if (location.query.page) {
        page = location.query.page;
      }
      if (0 < requestedBookings.length) {
        mainContainerSettings = AllOtherBookings;
      }
    } else if ('bookings' === route.path) {
      page = acceptedPageNum;
    }

    if (isError) {
      return (
        <ErrorPage
          button={this.props.intl.formatMessage({ id: 'inbox.bookings_main.error_button', defaultMessage: 'Okay' })}
          linkFn={this.reloadPage}
          link=""
        />
      );
    }

    const isAHost = _.get(profile, 'data.is_host', false);
    const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();

    return (
      <div className='inbox-container ps-container-lg-margin ps-container-fixed'>
        <div className='ps-row'>
          { isAHost && (
            <InboxPhishingBanner />
          )}
          <div className='col-xs-12'>
            {requestedBookings.length > 0 && (
              <div className='requested-bkgs-section'>
                <TabsContainer
                  loc={route.path}
                  tabs={pageObj.tabs}
                  showResponsive={isAHost}
                  hostResponse={hostResponse}
                />
                <InboxContainer
                  {...RequestedBookings}
                  body={requestedBookings}
                  location={route.path}
                  paginate={this.paginateRequestedInbox}
                  sort='requested'
                  pageNumber={requestedPageNum}
                  limit={settings.limit}
                  totalCount={requestedCount}
                  isLoading={requestedIsLoading}
                  showResponsive={false}
                />
              </div>
            )}
            <InboxContainer
              {...mainContainerSettings}
              body={bookings}
              location={route.path}
              paginate={this.paginateInbox}
              sort={settings.sort}
              pageNumber={page}
              limit={settings.limit}
              totalCount={count}
              isLoading={isLoading}
              showResponsive={!requestedBookings.length && isAHost}
              hostResponse={hostResponse}
            />
            {pastBookings.length > 0 && (
              <InboxContainer
                {...PastBookings}
                requestedBookings={[]}
                body={pastBookings}
                location={route.path}
                paginate={this.paginatePastInbox}
                sort='past'
                pageNumber={pastPageNum}
                limit={settings.limit}
                totalCount={pastBookingsCount}
                isLoading={pastIsLoading}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

BookingsMain.propTypes = {
  params: PropTypes.object,
  location: PropTypes.object,
  route: PropTypes.object,
  settings: PropTypes.object,
  profile: PropTypes.object,
  intl: intlShape
};

BookingsMain.contextTypes = {
  router: PropTypes.object
};

exports.BookingsMain = injectIntl(withTypeFormSurvey(BookingsMain));
